import React, { useEffect, useRef, useState } from "react";
import OptionsButton from "../../components/Common/buttons/OptionsButton";
import EwalletTiles from "../../components/Ewallet/EwalletTiles";
import EwalletTable from "../../components/Ewallet/EwalletTable";
import FundTransfer from "../../components/Ewallet/FundTransfer";
import { NavLink } from "react-router-dom";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FundconfirmModal from "../../components/Ewallet/FundconfirmModal";
import { Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { isActionRestricted, getUserKycStatus } from "../../utils/kycRestrictions";

const EwalletLayout = () => {
  const [showTransfer, setShowTransfer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmModal, setshowConfirmModal] = useState(false)
  const [confirmStatus, setconfirmStatus] = useState(false)
  const [fundTranferDetails, setfundTranferDetails] = useState(null)
  const hideButton = ApiHook.CallbuttonHide()
  const { t } = useTranslation();
  const submitRef = useRef()
  const style = {
    position: "absolute",
    inset: "0px auto auto 0px, margin: 0px",
    transform: "translate(190px, 42px)",
  };

  const handleEwalletTransfer = async () => {
    // Show message if KYC restricted
    if (isKycRestricted) {
      toast.warning(kycRestrictionMessage || t("kycRestrictionMessage"));
      return;
    }
    setShowTransfer((prevShowTransfer) => !prevShowTransfer);
    await hideButton.refetch();
  };
  const ewallet = ApiHook.CallEwalletTiles();
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );
  
  // Get KYC restrictions from Redux
  const appLayout = useSelector((state) => state?.dashboard?.appLayout);
  const kycRestrictions = appLayout?.kycRestrictions || [];
  const userKycStatus = getUserKycStatus(appLayout);
  const transferRestriction = isActionRestricted(kycRestrictions, 'balance_transfer', userKycStatus);
  const ewalletRestriction = isActionRestricted(kycRestrictions, 'ewallet', userKycStatus);
  const isKycRestricted = transferRestriction.isRestricted || ewalletRestriction.isRestricted;
  const kycRestrictionMessage = transferRestriction.message || ewalletRestriction.message;

  const handleCloseModal = () => {
    setshowConfirmModal(false)
  }
  const getFuntranferDetails = (data) => {
    setfundTranferDetails(data)
  }

  useEffect(() => {
    if (hideButton?.data?.hideButton) {
      setShowTransfer(false)
    }
  }, [hideButton?.data])

  return (
    <>
      <div className="page_head_top">{t("ewallet")}</div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          {/* Time-based restriction - only show alert for time-based */}
          {hideButton?.data?.hideButton && (
            <Alert variant="warning">
              {t("transfer_not_allowed")}.
            </Alert>
          )}
          <div className="col-md-4">
            {!!moduleStatus?.pin_status && (
              <>
                <NavLink className="btn_ewallt_page" activeclassname="active">
                  {t("ewallet")}
                </NavLink>
                <NavLink to={"/e-pin"} className="btn_ewallt_page">
                  {t("epin")}
                </NavLink>
              </>
            )}
          </div>
          <div className="col-md-4 text-end">
            <OptionsButton
              title={"ewallet_fund_transfer"}
              handleOpen={handleEwalletTransfer}
              style={style}
              type={"ewallet"}
              hideButton={hideButton?.data?.hideButton}
              purchaseDisabled={isKycRestricted}
              purchaseMessage={kycRestrictionMessage}
            />
          </div>
        </div>
      </div>
      <EwalletTiles
        tiles={ewallet?.data}
        currency={userSelectedCurrency}
        conversionFactor={conversionFactor}
      />
      <EwalletTable
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        currency={userSelectedCurrency}
      />
      <FundTransfer
        balance={ewallet?.data?.balance}
        show={showTransfer}
        handleClose={handleEwalletTransfer}
        currency={userSelectedCurrency}
        // setshowConfirmModal={setshowConfirmModal}
        // confirmStatus={confirmStatus}
        // getFundTranferDetails={getFuntranferDetails}
        // setconfirmStatus={setconfirmStatus}
        submitRef={submitRef}
      />
      {/* <FundconfirmModal
        show={showConfirmModal}
        close={handleCloseModal}
        setconfirmStatus={setconfirmStatus}
        fundTranferDetails={fundTranferDetails}
        currency={userSelectedCurrency}
        submitRef={submitRef}
      /> */}
    </>
  );
};

export default EwalletLayout;
